/**
 * 접근 제어 — 로그인 상태에 따른 기능 게이팅 (DES_FRN_접근제어_테스트페이지_정책.md).
 *
 * `/test/*` 페이지는 비로그인 접근 가능하지만, 일부 기능(D 카테고리)은 로그인 시에만 허용한다.
 * 페이지마다 if/else를 흩뿌리지 않고 이 composable의 능력값과 안내 함수를 사용한다.
 */

import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth.store'
import { useMonitoringStore } from '@/stores/monitoring.store'

const NOTIFY_AUTO_CLEAR_MS = 3000
const LOGIN_HINT_TOKEN = '로그인 후 사용 가능'

export function useAccessControl() {
  const auth = useAuthStore()
  const monitoring = useMonitoringStore()

  /** D 카테고리 — 녹화 등 서버 자원 관리 기능 */
  const canRecord = computed(() => auth.isLoggedIn)
  /** D 카테고리 — /admin/* 페이지 진입 능력 */
  const canManage = computed(() => auth.isLoggedIn)

  /** 비로그인 사용자가 D 기능 시도 시 안내. 토스트만 표시(LoginDialog 자동 오픈은 정책상 제외). */
  function notifyLoginRequired(feature: string) {
    const message = `${feature} 기능은 ${LOGIN_HINT_TOKEN}합니다.`
    monitoring.setUserMessage(message)
    setTimeout(() => {
      // 다른 메시지가 그 사이 덮어쓰지 않은 경우에만 클리어
      if (monitoring.userMessage === message) {
        monitoring.setUserMessage(null)
      }
    }, NOTIFY_AUTO_CLEAR_MS)
  }

  return { canRecord, canManage, notifyLoginRequired }
}
